import { render, staticRenderFns } from "./Reg.vue?vue&type=template&id=adc86c4c&scoped=true"
import script from "./Reg.vue?vue&type=script&lang=js"
export * from "./Reg.vue?vue&type=script&lang=js"
import style0 from "./Reg.vue?vue&type=style&index=0&id=adc86c4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc86c4c",
  null
  
)

export default component.exports